import { DatabaseEnum } from "@Shape-Digital/kudzu-data/lib/types/common";

import { Appointment } from "./types";
import { checkHasEditRole } from "./checkIsCanBeModified";

// Read/finished appointments: offerings are locked, only add-ons are editable
const checkIsCanEditAddOnsOnly = ({
  appointment,
  role,
}: {
  appointment: Appointment;
  role?: DatabaseEnum["center_user_role"];
}) => {
  if (!appointment || !checkHasEditRole(role)) {
    return false;
  }

  return ["studies_read", "reports_sent", "reports_error"].includes(
    appointment.status,
  );
};

export default checkIsCanEditAddOnsOnly;
